import {
    ImageSlider,
    ImageSliderAnalyticsEvent,
    ImageSliderCard,
    ThumbnailDisplay,
} from '@liveauctioneers/hammer-ui-core/imageSlider';

type Props = {
    cards: ImageSliderCard[];
    contentKey: number;
    desktopImageSize: number;
    mobileImageSize: number;
    onAnalyticsEventTriggered: (event: ImageSliderAnalyticsEvent) => void;
};

export const BiddingConsoleMainImageSlider = ({
    cards,
    contentKey,
    desktopImageSize,
    mobileImageSize,
    onAnalyticsEventTriggered,
}: Props) => (
    <ImageSlider
        cards={cards}
        contentKey={contentKey}
        iconShape="square"
        iconSize="sm"
        iconType="arrow"
        iconVariant="outlined"
        onAnalyticsEventTriggered={onAnalyticsEventTriggered}
        responsiveImageConfig={{
            breakpoint: 768,
            desktopSize: desktopImageSize,
            mobileSize: mobileImageSize,
        }}
        showThumbnails
        thumbnailDisplay={ThumbnailDisplay.Index}
        thumbnailOrientation="horizontal"
    />
);
